import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Sheet title shown at the top of the project navigation sheet */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectNavigationSheet.title?c=1674uh2rutges", defaultMessage: "Navigation" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
